import React from 'react';
import { Container} from 'react-bootstrap';
import img from '../../../images/my-image/borna.jpg';
import Typewriter from 'typewriter-effect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import {  faEnvelope, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Banner.css';

const Banner = () => {
   
     AOS.init();

    return (
        <section id="home-section">
        <Container>
            <div className="home-image">
                <img src={img} alt=""/>
            </div>

            <div className="text-center mt-5 banner">
                <h1>I'm DILRUBA <span className='theme'>BORNA</span></h1>
                <p className="program"><span className='text-dark'>I'm a - </span> 
                    <Typewriter
                        options={{
                        autoStart: true,
                        loop: true,   
                        }}    
                                onInit={(typewriter) => {    
                                 typewriter 
                                .changeCursor('<strong class="text_cursor">|</strong>')
                                .typeString('<strong class="typewriter_text">UI/UX Designer</strong>')
                                .pauseFor(2000)
                                .deleteChars(17)

                                .changeCursor('<strong class="text_cursor">|</strong>')
                                .typeString('<strong class="typewriter_text">React Developer</strong>')
                                .pauseFor(2000)
                                .start()
                                .deleteChars(19)

                                .changeCursor('<strong class="text_cursor">|</strong>')
                                .typeString('<strong class="typewriter_text">Web Developer</strong>')
                                .pauseFor(2000)
                                .start()
                                .deleteChars(19)
                                
                                .changeCursor('<strong class="text_cursor">|</strong>')
                                .typeString('<strong class="typewriter_text">Front End Developer</strong>')
                                .pauseFor(2000)
                                .deleteChars(25)
                                .changeCursor('<strong class="text_cursor"> |</strong>')
                                .start();
                                    }} 
                            />       
                        </p>                                               
            </div>      
             
                <div className='d-flex bannerIcon'>                          
                    <div className="text-sm-middle banner-icon">           
                        <a href="https://www.linkedin.com/in/dilruba-jannat-borna-09147b216/">
                        <FontAwesomeIcon icon={faLinkedinIn}  className='home-linkedin'/>
                        </a>          
                    </div>
                    <div className="text-sm-middle banner-icon mx-3">
                        <a href="https://github.com/JannatBorna">
                        <FontAwesomeIcon icon={faGithub} className='home-github'/>
                        </a>
                    </div>
                    <div className="text-sm-middle banner-icon">
                        <a href="mailto:boena.dilruba@gmail.com">
                        <FontAwesomeIcon icon={faEnvelope} className='home-mail'/>
                        </a>
                    </div> 
                </div>   

                <div className='mt-4'>
                    <FontAwesomeIcon icon={faArrowDown} className='faArrowDown'/>
                </div> 
                           
    </Container> 
  
</section>
    );
};



export default Banner;